import type { CandidateStatusApi } from '@/modules/candidates/types';
import type { components } from '@/types/apiSchema';

type SharedPrescreenLinkType =
  components['schemas']['CandidateJobPrescreeningType'];

/**
 * The pre-screen link is out and the call has not been recorded yet. Only
 * while Contacted: once the candidate is pre-screened the tag has done its job.
 */
const isPrescreenLinkPending = (
  status: CandidateStatusApi | string | null,
  sharedPrescreenLinkType: SharedPrescreenLinkType | null | undefined,
) => status === 'Contacted' && Boolean(sharedPrescreenLinkType);

interface PrescreenLinkSharedBadgeProps {
  status: CandidateStatusApi | string | null;
  sharedPrescreenLinkType: SharedPrescreenLinkType | null | undefined;
}

/** A tag after the candidate's name, not a status. */
export function PrescreenLinkSharedBadge({
  status,
  sharedPrescreenLinkType,
}: PrescreenLinkSharedBadgeProps) {
  if (!isPrescreenLinkPending(status, sharedPrescreenLinkType)) return null;
  return (
    <span className="bg-secondary-150 text-primary-700 inline-flex h-5 shrink-0 items-center rounded-[4px] px-1.5 text-xs font-medium whitespace-nowrap">
      Prescreen link shared
    </span>
  );
}
